import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../index';

const selectState = (state: AppState) => state.messageReplyTemplates;
export const selectMessageReplyTemplatesState = createSelector(selectState, (state) => state);
export const selectMessageReplyTemplatesFilters = createSelector(
  selectMessageReplyTemplatesState,
  ({ filters }) => filters,
);
